module.exports = __webpack_public_path__ + "media/images/ioscor_logo_blanco-7889f961df2f775322d8566fa8f9a676.svg";